import penaltyApi from "@/api/penalty";

export default {
  methods: {
    payPenalty(penalty) {
      penaltyApi.payPenalty(penalty.docId).then((paymentResponse) => {
        this.payment = paymentResponse.data
        if (typeof this.payment.link === 'string') {
          location.href = this.payment.link;
        }
      })
    }
  }
}
